import type { SigninRequirements } from '@sine/sine-core-api-types';

export function isHostRequired(siteRequirements: SigninRequirements, visitorTypeId: string) {
  return !!(siteRequirements.hostByVisitorTypeRequired || []).includes(visitorTypeId);
}
